import React, {useState, useEffect, useContext} from 'react';
import {Card, CardHeader, CardBody, Input, Table} from 'reactstrap';
import Loader from 'components/Loader';
import PaginationWrapper from 'components/PaginationWrapper';
import {securityGetUsers} from 'utils/api';
import sortAlphabetically from 'helpers/sortAlphabetically';
import {sortByValue} from 'helpers/sortByValue';
import {ErrorContext} from 'contexts/ErrorContext';
import SortableTableHeader from 'components/SortableTableHeader';
import './style.scss';
import OrganizationListItem from './OrganizationListItem';

const Organizations = () => {
    const {handleErrors} = useContext(ErrorContext);

    const [searchValue, setSearchValue] = useState('');
    const [fullUsersList, setFullUsersList] = useState(null);
    const [visibleList, setVisibleList] = useState(null);
    const [activeSortProperty, setActiveSortProperty] = useState('name');
    const [activeSortDirection, setActiveSortDirection] = useState('asc');
    const [fetchingData, setFetchingData] = useState(true);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [activeMobileSortSelection, setActiveMobileSortSelection] = useState('name-asc');

    useEffect(() => {
        fetchUsersList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(fullUsersList && visibleList) {
            applyFilters(true, fullUsersList);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeSortProperty, activeSortDirection, searchValue]);

    const applyFilters = (resetPage, list) => {
        let newArr = sortByValue(list, activeSortProperty, activeSortDirection);
        if(searchValue && searchValue.length > 0) {
            let arrFilteredBySearchValue = newArr.filter(item => {
                return item.name.toLowerCase().includes(searchValue.toLowerCase());
            });
            setVisibleList(arrFilteredBySearchValue);
            resetPage && setCurrentPageNumber(1);
        } else {
            setVisibleList(newArr);
            resetPage && setCurrentPageNumber(1);
        }
    };

    const fetchUsersList = async(refresh) => {
        try {
            !fetchingData && !refresh && setFetchingData(true);
            let usersData = await securityGetUsers();
            usersData.content.result.forEach(item => {
                if(item.name === null) item.name = '';
            });
            let initialList = sortAlphabetically(usersData.content.result, 'name');
            setFullUsersList(initialList);
            if(!refresh) {
                setVisibleList(initialList);
            }
            refresh && applyFilters(!refresh, initialList);
            setFetchingData(false);
        } catch(err) {
            console.log(err);
            handleErrors();
            setFetchingData(false);
        }
    };

    const handlePaginationClick = (pageNumber) => {
        setCurrentPageNumber(pageNumber.selected + 1);
    };

    const handleSortSelect = (sortValue) => {
        if(activeSortProperty === sortValue) {
            setActiveSortDirection(activeSortDirection === 'asc' ? 'desc' : 'asc');
        } else {
            setActiveSortProperty(sortValue);
            setActiveSortDirection('asc');
        }
    };

    const handleMobileSortSelect = (sortSelection) => {
        let splitArr = sortSelection.split('-');
        if(splitArr.length === 2) {
            setActiveSortProperty(splitArr[0]);
            setActiveSortDirection(splitArr[1]);
        }
        setActiveMobileSortSelection(sortSelection);
    };


    return (
        <div className="wrapper d-flex align-items-center mt-3 flex-column">
            <Card className="w-100">
                <CardHeader>
                    <h1 className="mb-0" style={{textAlign: 'center'}}>Organizations</h1>
                </CardHeader>
                {visibleList === null ? (
                    <div style={{padding: '3rem 2rem'}}>
                        <Loader small text="Fetching organization data"/>
                    </div>
                ) : (
                    <CardBody>
                        <div className="feeds-container_input">
                            {fullUsersList !== null && fullUsersList.length > 0 && (
                                <div className="feeds-container-wrapper">
                                    <Input
                                        style={{height: '35px'}}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        value={searchValue}
                                        placeholder="Search by organization name"
                                        type="text"
                                        className="searchInput"
                                    />
                                    {!searchValue ? (
                                        <i
                                            style={{position: 'absolute', top: '28%', bottom: '10.5px', right: '11px'}}
                                            className="fa fa-search search-container_icon"
                                        />
                                    ) : (
                                        <i
                                            style={{
                                                cursor: 'pointer',
                                                position: 'absolute',
                                                top: '28%',
                                                bottom: '10.5px',
                                                right: '11px',
                                            }}
                                            onClick={() => setSearchValue('')}
                                            className="fa fa-times-circle search-container_icon"
                                        />
                                    )}
                                </div>
                            )}
                        </div>

                        {fullUsersList && fullUsersList.length > 0 && (
                            <div className="feeds_sortBy">
                                <span>Sort by</span>
                                <Input onChange={(e) => handleMobileSortSelect(e.target.value)} type="select"
                                       value={activeMobileSortSelection}>
                                    <option value="name-asc">User (A to Z)</option>
                                    <option value="name-desc">User (Z to A)</option>
                                    <option value="isSingleUser-desc">Organization Type ('Teams' first)</option>
                                    <option value="isSingleUser-asc">Organization Type ('Single' first)</option>
                                    <option value="timezone-asc">Timezone (A to Z)</option>
                                    <option value="timezone-desc">Timezone(Z to A)</option>
                                    {/*<option value="userTZ">User's TZ (A to Z)</option>*/}
                                    {/*<option value="userTZDescending">User's TZ (Z to A)</option>*/}
                                    <option value="createdAt-desc">Created at (Newest to Oldest)</option>
                                    <option value="createdAt-asc">Created at (Oldest to Newest)</option>
                                    {/*<option value="feedscount">Feeds Count (1 to 9)</option>*/}
                                    {/*<option value="feedscountDescending">Feeds Count (9 to 1)</option>*/}
                                </Input>
                            </div>
                        )}
                        {/* <div>
                            <Button className="typical-button" style={{ color: 'white' }} onClick={() => reactivateFacebook(true)}>
                                Reactivate Facebook Accounts
                            </Button>
                        </div> */}
                        <div className="table mt-3">
                            {fullUsersList && fullUsersList.length > 0 ? (
                                <Table style={{color: '#314784'}} responsive>
                                    <thead className="hidden">
                                    <tr>
                                        <SortableTableHeader
                                            name="Organization"
                                            value="name"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('name')}
                                        />
                                        <SortableTableHeader
                                            name="Organization Type"
                                            value="isSingleUser"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('isSingleUser')}
                                        />
                                        <SortableTableHeader
                                            name="Timezone"
                                            value="timezone"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('timezone')}
                                        />
                                        <SortableTableHeader
                                            name="Created At"
                                            value="createdAt"
                                            activeSortValue={activeSortProperty}
                                            activeSortDirection={activeSortDirection}
                                            handleSelect={() => handleSortSelect('createdAt')}
                                        />
                                        {/*<SortableTableHeader*/}
                                        {/*    name="Feeds Count"*/}
                                        {/*    value="feedsCount"*/}
                                        {/*    activeSortValue={activeSortProperty}*/}
                                        {/*    activeSortDirection={activeSortDirection}*/}
                                        {/*    handleSelect={() => handleSortSelect('feedsCount')}*/}
                                        {/*/>*/}
                                        <th style={{minWidth: '100px'}}>
                                            Limits
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {fetchingData ? (
                                        <tr>
                                            <td className="mt-5"><Loader/></td>
                                        </tr>
                                    ) : (
                                        <React.Fragment>
                                            {visibleList && visibleList.length > 0 ? (
                                                visibleList.slice((currentPageNumber - 1) * 50, currentPageNumber * 50).map((item, index) => (
                                                    <OrganizationListItem
                                                        key={index}
                                                        item={item}
                                                        refreshList={fetchUsersList}
                                                    />
                                                ))
                                            ) : (
                                                <tr>
                                                    <td className="mt-5">No matching results</td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    )}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="mt-5">No users found</p>
                            )}
                        </div>
                        {visibleList && visibleList.length > 50 && (
                            <PaginationWrapper
                                totalPages={Math.ceil(visibleList.length / 50)}
                                handlePageClick={handlePaginationClick}
                            />
                        )}
                    </CardBody>
                )}
            </Card>
        </div>
    );
};

export default Organizations;
